import absencesApi from '../../api/absences-api'

const state = {
  absence: {},
  items: [],
  requestTypes: [],
  totalItems: 0,
}

const mutations = {
  setAbsence(state, val) {
    state.absence = val
  },
  setItems(state, val) {
    state.items = val
  },
  setTotalItems(state, val) {
    state.totalItems = val
  },
  setRequestTypes(state, val) {
    state.requestTypes = val
  },
  updateItem(state, updatedItem) {
    const index = state.items.findIndex(i => i.id === updatedItem.id)
    if (index !== -1) {
      state.items.splice(index, 1, { ...state.items[index], files: updatedItem.files })
    }
  },
}

const actions = {
  async getAbsence({ commit }, id) {
    commit('app/loading', true, { root: true })
    await absencesApi.getAbsence(id)
      .then(
        response => {
          commit('setAbsence', response.data.data)
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al obtener la ausencia.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  getListAbsences({ commit }, {
    page, per_page, type_id = '', user_id = '', date_ini = '', date_fin = '', status = '', client_id = '', department_id = '', include_team = false
  }) {
    commit('app/loading', true, { root: true })
    return absencesApi.list(page, per_page, user_id, type_id, date_ini, date_fin, status, client_id, department_id, include_team)
      .then(
        response => {
          commit('setItems', response.data.data)
          commit('setTotalItems', response.data.meta.total[1])
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al obtener el listado de ausencias.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  getRequestTypes({ commit }) {
    commit('app/loading', true, { root: true })
    absencesApi.requestTypes()
      .then(
        response => {
          commit('setRequestTypes', response.data)
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al obtener el listado de tipos.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  edit({ commit }, { id, absence }) {
    commit('app/loading', true, { root: true })
    absencesApi.edit(id, absence)
      .then(
        () => {
          commit('notifications', { title: 'Ausencia actualizada con éxito.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          location.reload()
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al actualizar la ausencia.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  approve({ commit }, { id, absence }) {
    commit('app/loading', true, { root: true })
    absencesApi.approve(id, absence)
      .then(
        () => {
          commit('notifications', { title: 'Ausencia actualizada con éxito.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          location.reload()
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al actualizar la ausencia.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  create({ commit }, { absence }) {
    commit('app/loading', true, { root: true })
    absencesApi.create(absence)
      .then(
        response => {
          commit('notifications', { title: 'Ausencia creada con éxito.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          location.reload()
          commit('app/loading', false, { root: true })
        },
        error => {
          commit('app/loading', false, { root: true })
          let errorMsg = 'Error al crear la ausencia.'
          if (error && error.response && error.response.data && error.response.data.error) {
            errorMsg = error.response.data.error
          }
          commit('notifications', { title: errorMsg, variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  createdirect({ commit }, { absence }) {
    commit('app/loading', true, { root: true })
    absencesApi.createdirect(absence)
      .then(
        response => {
          commit('notifications', { title: 'Ausencia creada con éxito.', variant: 'success' }, { root: true })
          location.reload()
        },
        error => {
          commit('app/loading', false, { root: true })
          let errorMsg = 'Error al crear la ausencia.'
          if (error && error.response && error.response.data && error.response.data.error) {
            errorMsg = error.response.data.error
          }
          commit('notifications', { title: errorMsg, variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  uploadDocument({ commit }, { id, formData }) {
    commit('app/loading', true, { root: true })
    return absencesApi.uploadDocument(id, formData)
      .then(
        response => {
          commit('updateItem', response.data.data)
          commit('notifications', { title: 'Documento subido con éxito.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          commit('app/loading', false, { root: true })
          return response.data.data
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al subir el documento.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  deleteDocument({ commit }, { id, fileId }) {
    commit('app/loading', true, { root: true })
    return absencesApi.deleteDocument(id, fileId)
      .then(
        response => {
          commit('updateItem', response.data.data)
          commit('notifications', { title: 'Documento eliminado.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          commit('app/loading', false, { root: true })
          return response.data.data
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al eliminar el documento.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  delete({ commit }, id) {
    commit('app/loading', true, { root: true })
    absencesApi.delete(id)
      .then(
        () => {
          commit('notifications', { title: 'Ausencia eliminada con éxito.', variant: 'success' }, { root: true })
          location.reload()
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al eliminar la ausencia.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },

}

const getters = {
  getAbsence: state => state.absence,
  getItems: state => state.items || [],
  getTotalItems: state => state.totalItems,
  getRequestTypes: state => state.requestTypes,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
